import React, { useState, useRef, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";
import PatientService from "../../services/PatientService";
import CopayHeader from "../CopayHeader";
import Footer from "../Footer";
import HcpEnrollThankyouModal from "../modal/Hcp/HcpEnrollThankyouModal";
import useModal from "../modal/useModal";
import { CoPayHcpWelcomeValSchema } from "../ValidationForm/validationSchema";
import { getSMSText } from "../../common/utilities";
import { ABSOLUTE_URL } from "../../common/constants";
import Loader from "./../../common/Loader";
import smsTemplateService from "../../services/smsTemplateService";
import $ from 'jquery'; // Import jQuery
import 'bootstrap-datepicker';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.css';
import { currentDate } from "../../common/commonFun";

const HcpWelcome = () => {
  const form = useRef();
  const copayhcpId = localStorage.getItem("copayhcpId");
  const [loading, setLoading] = useState(false);
  const { isShowing: isShowingThankyou, toggle: toggleThankyou } = useModal();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset, clearErrors
  } = useForm({
    resolver: yupResolver(CoPayHcpWelcomeValSchema),
    defaultValues: { hcpId: copayhcpId },
  });

  useEffect(() => {
    // Initialize datepicker
    $('#dob').datepicker({
      format: 'dd/mm/yyyy', 
      startView: 2,
      startDate: '01/01/1900', 
      endDate: currentDate(),
      autoclose: true,
      defaultViewDate: { year: 1955, month: 4, day: 25 },
    }).on('changeDate', function (e) {
      const formattedDate = e.format('yyyy-mm-dd');
      setValue("dob", formattedDate); 
      if (errors.dob) {
        clearErrors("dob");
      }
    });

    // Set default value from URL params if available
    const urlParams = new URLSearchParams(window.location.search);
    const birthday = urlParams.get('birthday');
    if (birthday) {
      setValue("dob", birthday);
    }
  }, [setValue, errors, clearErrors]);


  const handleEnroll = async (data) => {
    setLoading(true);
    PatientService.createPatientEnroll(data).then(
      async (response) => {
        setLoading(false);
        reset();
        toggleThankyou();

        const patientDetail = response.data.patientDetail;
        try {
          let insert_link = ABSOLUTE_URL + "co-pay-patient/" + patientDetail.id;

          let smsText = await getSMSText("sms_enrol_hcp_patient", [
            { patient_first_name: patientDetail.firstname },
            { insert_link: insert_link },
          ]);

          if (
            smsText !== null &&
            smsText !== undefined &&
            patientDetail.smsEnabled
          ) {
            // smsTemplateService.sendSMS({to:"+918511367064", msg:smsText,userType:"patient",userId:patientDetail.id});
             smsTemplateService.sendSMS({ to: patientDetail.mobile, msg: smsText, userType: "patient", userId: patientDetail.id, });
          }
        } catch (error) {
          console.error("Error while fetching SMS text:", error);
          toast.error("Error while fetching SMS text:", error);
        }
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        setLoading(false);
        toast.error(resMessage);
      }
    );
  };

  return (
    <>
      <HcpEnrollThankyouModal
        isShowing={isShowingThankyou}
        hide={toggleThankyou}
      />
      <CopayHeader />
      {loading && <Loader />}
      <main className="inner-page">
        <section className="container">
          <div className="row">
            <div className="col-sm-12">
              <h1 className="text-uppercase">Patient Details</h1>
              <div className="spacer-2"></div>
            </div>
          </div>
          <div className="row gx-3 justify-content-between">
            <div className="width-lg-53">
              <form
                autoComplete="off"
                className="custom-form"
                onSubmit={handleSubmit(handleEnroll)}
                ref={form}
              >
                <div className="row">
                  <div className="col-sm-12">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="First name"
                      name="firstname"
                      {...register("firstname")}
                    />
                    {errors.firstname && (
                      <span>{errors.firstname.message}</span>
                    )}
                  </div>
                </div>
                <div className="spacer-1"></div>
                <div className="row">
                  <div className="col-sm-12">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Last name"
                      name="lastname"
                      {...register("lastname")}
                    />
                    {errors.lastname && <span>{errors.lastname.message}</span>}
                  </div>
                </div>
                <div className="spacer-1"></div>
                <div className="row">
                  <div className="width-lg-22 d-flex align-items-center">
                    <label className="form-label mb-md-0 fw-bold">
                      Date of Birth
                    </label>
                  </div>
                  <div className="width-lg-78">
                    <div className="row">
                      <div className="col-sm-6">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="dd/mm/yyyy"
                          id="dob"
                          name="dob"
                          readOnly // Ensure the input field is read-only
                          {...register("dob")}
                        />
                      </div>
                      {errors.dob && <span>{errors.dob.message}</span>}
                    </div>
                  </div>
                </div>
                <div className="spacer-2"></div>
                <div className="row">
                  <div className="width-lg-22">
                    <label className="form-label mb-md-0 fw-bold">Gender</label>
                  </div>
                  <div className="width-lg-78">
                    <div>
                      <div className="form-check form-check-inline d-inline-flex align-items-center">
                        <input
                          className="form-check-input mt-0"
                          type="radio"
                          name="gender"
                          id="inlineRadio1"
                          value="Male"
                          {...register("gender")}
                        />

                        <label
                          className="form-label fs-16 mb-0 ps-1 text-wrap lh-1"
                          htmlFor="inlineRadio1"
                        >
                          Male
                        </label>
                      </div>
                      <div className="form-check form-check-inline d-inline-flex align-items-center">
                        <input
                          className="form-check-input mt-0"
                          type="radio"
                          name="gender"
                          id="inlineRadio2"
                          value="Female"
                          {...register("gender")}
                        />

                        <label
                          className="form-label fs-16 mb-0 ps-1 text-wrap lh-1"
                          htmlFor="inlineRadio2"
                        >
                          Female
                        </label>
                      </div>
                      <div className="form-check form-check-inline d-inline-flex align-items-center">
                        <input
                          className="form-check-input mt-0"
                          type="radio"
                          name="gender"
                          id="inlineRadio3"
                          value="other"
                          {...register("gender")}
                        />

                        <label
                          className="form-label fs-16 mb-0 ps-1 text-wrap lh-1"
                          htmlFor="inlineRadio3"
                        >
                          Other
                        </label>
                      </div>
                    </div>
                    {errors.gender && <span>{errors.gender.message}</span>}
                  </div>
                </div>
                <div className="spacer-1"></div>
                <div className="row">
                  <div className="col-sm-12 mb-3">
                    <input
                      type="text"
                      className="form-control fs-18"
                      placeholder="Mobile number"
                      name="mobile"
                      {...register("mobile")}
                    />

                    <div className="form-text text-dark-gray" id="basic-addon4">
                      This can be the patient’s mobile or their support person’s
                      mobile number.{" "}
                    </div>
                    {errors.mobile && <span>{errors.mobile.message}</span>}
                  </div>
                  <div className="col-sm-12 mb-3">
                    <select
                      name="indication"
                      className="form-select" 
                      {...register("indication")}
                    >
                      <option value="The Indication" selected>
                        The Indication
                      </option>
                      {/* <option value="value 2">Value 2</option> */}
                      {/* <option value="value 3">Value 3</option> */}
                    </select>
                    {errors.indication && (
                      <span>{errors.indication.message}</span>
                    )}
                  </div>
                </div>
                <div className="spacer-1"></div>
                <div className="row">
                  <div className="col-sm-12">
                    <h4 className="mb-2 fs-18 fw-bold text-dark-gray">
                      Patient Consent
                    </h4>
                    <div className="form-check d-flex align-items-center">
                      <input
                        className="form-check-input mt-0"
                        type="radio"
                        name="Consent"
                        id="Consent"
                        {...register("Consent")}
                      />

                      <label
                        className="form-label fs-16 mb-0 ps-2 text-wrap lh-1"
                        htmlFor="flexRadioDisabled"
                      >
                        I have consent from my patient to provide their personal
                        details and enrol them in the Program
                      </label>
                    </div>
                    {errors.Consent && <span>{errors.Consent.message}</span>}
                    <div className="form-check d-flex align-items-center mt-3">
                      <input
                        className="form-check-input mt-0"
                        type="radio"
                        name="flexRadioDisabled"
                        id="flexRadioCheckedDisabled"
                        {...register("flexRadioDisabled")}
                      />

                      <label
                        className="form-label fs-16 mb-0 ps-2 text-wrap lh-1"
                        htmlFor="flexRadioCheckedDisabled"
                      >
                        I have explained to my patient that the Program runs for
                        x months at which time, the program may be extended or
                        ceased
                      </label>
                    </div>
                    {errors.flexRadioDisabled && (
                      <span>{errors.flexRadioDisabled.message}</span>
                    )}
                  </div>
                </div>
                <div className="spacer-5"></div>
                <div className="row">
                  <div className="col-sm-12">
                    <button className="btn btn-primary btn-default btn-block d-md-inline-block">
                      Enrol
                    </button>
                  </div>
                </div>
                <div className="spacer-5"></div>
              </form>
            </div>
            <div className="width-lg-43">
              <div className="card bg-teal rounded-0 border-0 text-center p-4 h-100 d-flex justify-content-center">
                <p className="mb-0 fs-24 fw-bold text-white lh-sm">
                  Topline overview of the <br /> Program and Benefits
                </p>
              </div>
            </div>
          </div>
        </section>
        <section></section>
      </main>
      <Footer />
    </>
  );
};

export default HcpWelcome;
